import { RootState } from 'store';

export const selectors = {
  selectMnemonicCardsPack: (state: RootState) => state.mnemonicCards.mnemonicCardsPack,
  selectMnemonicCardsPackMeta: (state: RootState) => state.mnemonicCards.meta,
  selectCurrentMnemonicCardsPackId: (state: RootState) => state.mnemonicCards.currentMnemonicCardsPackId,
  selectPackName: (state: RootState) => state.mnemonicCards.packName,
};
